import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/common/tool-tip-component';
import { ReactComponent as SwapIcon } from 'icons/swap.svg';

const ICON_SIZE = 25;

export const SideBySideViewSubHeader = ({ BLOCK, onClick }) => {
  return (
    <div className={`${BLOCK}__subheader`}>
      <div className={`${BLOCK}__subheader-container`}>
        <Tooltip
          text="side-by-side-view.compare.subheader.tooltip.info"
          id={`${BLOCK}-id-subheader-info-tooltip`}
          className={`${BLOCK}__swap-icon-tooltip`}
        >
          <div
            className={`${BLOCK}__subheader-wrap`}
            onClick={onClick}
          >
            <div className={`${BLOCK}__swap-icon`}>
              <SwapIcon width={ICON_SIZE} height={ICON_SIZE} />
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

SideBySideViewSubHeader.propTypes = {
    /** Block name for BEM class naming */
    BLOCK: PropTypes.string.isRequired,
    /** onClick handler for swap icon */
    onClick: PropTypes.func.isRequired,
};

export default SideBySideViewSubHeader;
